import { useEffect } from 'react';
import axios from 'axios';
import useModalStore from '../../../../zustand/store/useModalStore';

import '../../../../css/modal.css'

const NotConnectReasonList_layer = ({isModalOpen, modalClose, reasonList, updateParams, handleUpdateInputChange, setReSearch}) => {

    const useridno = localStorage.getItem('id');
    const modalCode = isModalOpen.errocode;
    const modalbigo = isModalOpen.bigo;

    const showNotiModal = useModalStore(state => state.showNotiModal);

    const updateNedisSendErro = async (updateParams) => {
        try {
            if(window.confirm("입력된 미 입력사유 정보를 저장하시겠습니까?")) {
                await axios.post('/ptmiapi/nedis/agent/updateNedisSendErro.do', {
                    useridno: useridno,
                    errocode: updateParams.errocode,
                    erroetc: updateParams.bigo,
                    erro_seq: String(updateParams.erro_seq),
                });
                modalClose();
                showNotiModal('저장되었습니다.')
                setReSearch(true);
            }
        } catch (error) {
            console.error('입력사유 저장 중 오류 발생:', error);
        }
    };
    
    const save = (updateParams) => {
        const keyLabelMap = {
            errocode: '미 연결사유를 선택해주세요.',
            bigo: '비고는 필수입니다.',
            erro_seq: 'id를 찾을 수 없습니다.'
        };
        
        const validationCheckList = ['errocode', 'bigo', 'erro_seq']
        const isValid = validationCheckList?.every(key => {
            // 빈 값 체크
            const label = keyLabelMap[key] || key;
            if (!updateParams[key]) {
                alert(`${label}`);
                return false;
            };
            // 글자수 체크
            if(updateParams.bigo) {
                const getByte = getByteLength(updateParams.bigo);
                if (getByte > 500) {
                    // alert(`입력 내용이 너무 깁니다. 현재 ${getByte} byte / 최대 500 byte`);
                    alert("입력된 비고내용을 100자 이내로 작성해주세요.");
                    return false;
                }
            };
            return true;
        });

        if (isValid === false) return;

        updateNedisSendErro(updateParams);
    };

    const getByteLength = (text) => {
        let byteLength = 0;
        for (let i = 0; i < text.length; i++) {
            const charCode = text.charCodeAt(i);
            if (charCode <= 0x007f) {
            byteLength += 1; // ASCII 문자
            } else if (charCode <= 0x07ff) {
            byteLength += 2; // 라틴, 일부 기호
            } else {
            byteLength += 2; // 대부분의 한글, 한자, 기타
            }
        }
        return byteLength;
    };

    // esc 키 누르면 모달 닫히는 기능
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === "Escape") modalClose();
        };
    
        // 이벤트 리스너 등록
        document.addEventListener("keydown", handleEscape);
    
        // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
        return () => {
            document.removeEventListener("keydown", handleEscape);
        };
    }, [modalClose]);

    return (
        <>
        {isModalOpen.modalState && 
            <div className='layer_container'>
                <div className='layer_wrapper'>
                    <div className='modal_title_box'>
                        <h4>{modalCode ? 'Agent PC 미 연결 사유 확인' : 'Agent PC 미 연결 사유를 입력해 주세요.'}</h4>
                    </div>
                    {modalCode ? '' :
                        <div className='text-center'>
                            <p className='bold co_red'>입력된 미 전송 사유는 수정이 불가능 합니다.</p>
                            <p className='bold co_red'>최초 기입시 정확히 입력 해 주시기 바랍니다.</p>
                        </div>
                    }
                    <hr/>
                    <div className='layer_section'>
                        <h5>미 연결 사유</h5>
                        <hr/>
                        <div className='radio_wrapper'>
                            {reasonList?.map((reason) => 
                                <p key={reason.bscdminr} className='w-48 my-1 mx-2 errocode_w_media_set'>
                                    <input type="radio" id={'errocode'+ reason.bscdminr} name="errocode" 
                                    disabled={modalCode ? true : false}
                                    defaultChecked={modalCode === reason.bscdminr ? modalCode : ''}
                                    value={reason.bscdminr} 
                                    onChange={handleUpdateInputChange}/>
                                    <label htmlFor={'errocode'+ reason.bscdminr}>{reason.bscddesc}</label>
                                </p>
                            )}
                        </div>
                        <hr/>
                    </div>
                    <div className='layer_section'>
                        <h5>비고</h5>
                        <hr/>
                        <textarea name="bigo" disabled={modalbigo ? true : false}
                            className='textarea_style h-24'
                            placeholder='비고를 작성해 주세요.'
                            defaultValue={modalbigo ? modalbigo : ''} 
                            onChange={handleUpdateInputChange}/>
                    </div>
                    <hr />
                    <div className='modal_btn_box'>
                        <div className={`modal_btn ${!modalCode ? 'bg_st_primary cursor-pointer' : 'bg_co_light'}`} onClick={() => !modalCode ? save(updateParams) : ''}>저장</div>
                        <div className='modal_btn bg_co_black cursor-pointer' onClick={modalClose}>닫기</div>
                    </div>
                </div>
            </div>
        }
        </>
    )
}

export default NotConnectReasonList_layer